import { useEffect, useState } from 'react'
import { apiClient } from 'core/http'
import { adminService } from 'core/services/adminService'
import { formatNumbers } from 'core/helpers/format-numbers'

import c from './assets/sass/user-tasks-modal.module.scss'

export const UserTasksModal = ({ userId, onClose }) => {
    const [tasks, setTasks] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        loadTasks()
    }, [userId])

    const loadTasks = async () => {
        try {
            const res = await adminService.getUserTasks(userId)
            if (res?.tasks) {
                setTasks(res.tasks)
            }
        } catch (error) {
            console.error('Failed to load user tasks:', error)
        } finally {
            setLoading(false)
        }
    }

    const handleReset = async (taskId) => {
        if (!window.confirm('Откатить выполнение задания?')) return
        try {
            await adminService.resetUserTask(userId, taskId)
            loadTasks()
            alert('Задание сброшено!')
        } catch (error) {
            alert('Ошибка: ' + error.message)
        }
    }

    return (
        <div className={c.overlay} onClick={onClose}>
            <div className={c.modal} onClick={(e) => e.stopPropagation()}>
                <div className={c.header}>
                    <h3>Выполненные задания</h3>
                    <button className={c.close} onClick={onClose}>
                        ×
                    </button>
                </div>
                <div className={c.content}>
                    {loading ? (
                        <div className={c.loading}>Загрузка...</div>
                    ) : tasks.length === 0 ? (
                        <div className={c.empty}>Заданий нет</div>
                    ) : (
                        <div className={c.list}>
                            {tasks.map((task) => (
                                <div key={task.id} className={c.task}>
                                    <div className={c.taskInfo}>
                                        <span className={c.title}>
                                            {task.title}
                                        </span>
                                        <span className={c.reward}>
                                            💰{' '}
                                            {formatNumbers(
                                                parseInt(task.reward || 0)
                                            )}
                                            {task.energyReward > 0 &&
                                                ` + ⚡ ${task.energyReward}`}
                                        </span>
                                        <span className={c.status}>
                                            {task.status === 'COMPLETED'
                                                ? '✅ Выполнено'
                                                : task.status}
                                        </span>
                                        {task.completedAt && (
                                            <span className={c.date}>
                                                {new Date(
                                                    task.completedAt
                                                ).toLocaleString('ru-RU')}
                                            </span>
                                        )}
                                    </div>
                                    {task.status === 'COMPLETED' && (
                                        <button
                                            className={c.reset}
                                            onClick={() =>
                                                handleReset(task.taskId)
                                            }
                                        >
                                            Сбросить
                                        </button>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
